import axios from "axios";

export const API = `/data/`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ob_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ ما، حاول مرة أخرى.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CURRENCY_META = {
  USD: { flag: "🇺🇸" }, YER: { flag: "🇾🇪" }, SAR: { flag: "🇸🇦" }, EUR: { flag: "🇪🇺" },
};

export function fmtMoney(value, decimals = 2) {
  const n = Number(value || 0);
  return n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
